var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import ErrorHandler from '@/support/ErrorHandler';
import { ucstring } from '@/support/String';
let Notes = class Notes extends Vue {
    constructor() {
        super(...arguments);
        // protected quillToolbarOptions: any[] = [
        //   ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        //   ['blockquote', 'code-block'],
        //   [{ 'header': 1 }, { 'header': 2 }, , { 'header': 3 }], // custom button values
        //   [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        //   [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        //   [{ 'direction': 'rtl' }],                         // text direction
        //   [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        //   [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        //   [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        //   [{ 'font': [] }],
        //   [{ 'align': [] }],
        //   ['clean']                                         // remove formatting button
        // ];
        this.content = '';
        this.editorOptions = {
            modules: {
                magicUrl: true,
            },
        };
    }
    mounted() {
        this.content = this.subject.description || '';
    }
    onEditorBlur(quill) {
        //
    }
    onEditorFocus(quill) {
        //
    }
    onEditorReady(quill) {
        //
    }
    onEditorChange(quill, html, text) {
        this.content = html;
    }
    save() {
        this.subject
            .update({ description: this.content })
            .then(() => {
            this.$store.dispatch('openDialog', this.dialogOptions);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get dialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: ucstring(this.$t('dialogOptions.save', { item: this.$t('dialogOptions.item.note') }).toString()),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                },
            },
        };
    }
};
__decorate([
    Model('subject'),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], Notes.prototype, "subject", void 0);
Notes = __decorate([
    Component({
        components: {
            quillEditor,
        },
    })
], Notes);
export default Notes;
